module.exports = __webpack_public_path__ + "img/logo.58f18d40.svg";